<template>
    <ListeRapportRelance/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeRapportRelance from "@/components/GesCom/RapportRelance/ListeRapportRelance.vue";

    export default defineComponent({
      name: "ListeRapportRelancePage",
      components: {
        
        ListeRapportRelance,
      },
    });
  </script>